import React, {useEffect} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading } from '../Actions/setLoading';
import { ToastContainer, toast } from 'react-toastify';
import Ariis from './Ariis';
import { ipCheckApi } from '../Services/transferData';


const App = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => {dispatch(setLoading())},1500)

        checkVpnSituation();
    },[dispatch]);

    
    const checkVpnSituation = async () => {
        try {
            const {status} = await ipCheckApi();
            if (status === 201) {
                toast("برای بهبود عملکرد اپلیکیشن،لطفا VPN خود را خاموش کنید.",{
                    position:"top-right",
                    autoClose:5000,
                    closeOnClick:false,
                    toastId:"apiCheck",
                    style:{
                        width:`${window.innerWidth > 768 ? "50vw": "80vw"}`,
                        textAlign:"center",
                    }
                })
            }
        } catch (error) {
            console.error(error);
        }
    };
    return ( 
        <>
            <BrowserRouter>
                <Ariis/>
            <ToastContainer/>
            </BrowserRouter>
        </>
    );
}
 
export default App;
